"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: common/service-extensions.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcommon%2Fservice-extensions.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.methodOperationTypeToJSON = exports.methodOperationTypeFromJSON = exports.AuthenticationOptions = exports.MethodOperationType = void 0;
const audience_1 = require("./audience");
const auth_level_1 = require("./auth-level");
const protobufPackage = 'com.step.common.proto';
/**
 * Declares whether a method is a read or write operation.
 */
var MethodOperationType;
(function (MethodOperationType) {
    MethodOperationType["INVALID_METHOD_OPERATION_TYPE"] = "INVALID_METHOD_OPERATION_TYPE";
    MethodOperationType["READ_METHOD"] = "READ_METHOD";
    MethodOperationType["WRITE_METHOD"] = "WRITE_METHOD";
    MethodOperationType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(MethodOperationType || (exports.MethodOperationType = MethodOperationType = {}));
function createBaseAuthenticationOptions() {
    return {
        level: undefined,
        allowSuspended: undefined,
        allowAdminImpersonated: undefined,
        allowSponsorImpersonated: undefined,
        audience: [],
    };
}
exports.AuthenticationOptions = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.level)) {
            message.level = (0, auth_level_1.authLevelFromJSON)(object.level);
        }
        if (isSet(object.allowSuspended)) {
            message.allowSuspended = globalThis.Boolean(object.allowSuspended);
        }
        if (isSet(object.allowAdminImpersonated)) {
            message.allowAdminImpersonated = globalThis.Boolean(object.allowAdminImpersonated);
        }
        if (isSet(object.allowSponsorImpersonated)) {
            message.allowSponsorImpersonated = globalThis.Boolean(object.allowSponsorImpersonated);
        }
        if (globalThis.Array.isArray(object?.audience)) {
            message.audience = object.audience.map((e) => (0, audience_1.audienceFromJSON)(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.level !== undefined) {
            obj.level = (0, auth_level_1.authLevelToJSON)(message.level);
        }
        if (message.allowSuspended !== undefined) {
            obj.allowSuspended = message.allowSuspended;
        }
        if (message.allowAdminImpersonated !== undefined) {
            obj.allowAdminImpersonated = message.allowAdminImpersonated;
        }
        if (message.allowSponsorImpersonated !== undefined) {
            obj.allowSponsorImpersonated = message.allowSponsorImpersonated;
        }
        if (message.audience?.length) {
            obj.audience = message.audience.map((e) => (0, audience_1.audienceToJSON)(e));
        }
        return obj;
    },
    create(base) {
        return exports.AuthenticationOptions.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAuthenticationOptions();
        message.level = object.level ?? undefined;
        message.allowSuspended = object.allowSuspended ?? undefined;
        message.allowAdminImpersonated = object.allowAdminImpersonated ?? undefined;
        message.allowSponsorImpersonated = object.allowSponsorImpersonated ?? undefined;
        message.audience = object.audience?.map((e) => e) || [];
        return message;
    },
};
function methodOperationTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_METHOD_OPERATION_TYPE':
            return MethodOperationType.INVALID_METHOD_OPERATION_TYPE;
        case 1:
        case 'READ_METHOD':
            return MethodOperationType.READ_METHOD;
        case 2:
        case 'WRITE_METHOD':
            return MethodOperationType.WRITE_METHOD;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return MethodOperationType.UNRECOGNIZED;
    }
}
exports.methodOperationTypeFromJSON = methodOperationTypeFromJSON;
function methodOperationTypeToJSON(object) {
    switch (object) {
        case MethodOperationType.INVALID_METHOD_OPERATION_TYPE:
            return 'INVALID_METHOD_OPERATION_TYPE';
        case MethodOperationType.READ_METHOD:
            return 'READ_METHOD';
        case MethodOperationType.WRITE_METHOD:
            return 'WRITE_METHOD';
        case MethodOperationType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.methodOperationTypeToJSON = methodOperationTypeToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=service-extensions.js.map